import React from 'react'
import Lottie from 'react-lottie'

import contentOne from '../srcAnimationJson/content1.json'

import './HomeContentOne.module.scss'

class HomeContentOne extends React.Component {
  static defaultProps = {
    height: 270,
    width: 270
  }

  render () {
    const { width, height } = this.props
    const headerEffect = {
      loop: true,
      autoplay: true,
      animationData: contentOne,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    }

    return (
      <div className='atom-animation' style={{ height }}>
        <Lottie
          options={headerEffect}
          height={height}
          width={width}
        />
      </div>
    )
  }
}

export default HomeContentOne

